import type { Route } from '@angular/router';

/** 팀 입장 라우트가 단체 기본 뷰에서 그대로 물려받는 설정 — `path`만 이 헬퍼가 `teams/:teamId`로 정한다. */
export type OrgTeamEntryTarget = Omit<Route, 'path'>;

/**
 * 팀 단위 입장 라우트 — `orgs/:orgId/teams/:teamId`. 학교종이 매직링크의 팀 입장(`activeTeamId`)이 들어오는 주소이고, 백엔드 API 경로(`/orgs/:orgId/teams/:teamId`)와 같은 모양이다.
 * `orgs/:orgId`의 children에 펼친다:
 *
 * ```ts
 * { path: 'orgs/:orgId', children: [
 *   { path: '', loadComponent: () => import('./org-home.component') },
 *   orgTeamEntryRoute({ loadComponent: () => import('./org-home.component') }),  // 팀 뷰가 없는 앱: 단체 기본 뷰를 그대로
 * ] }
 * ```
 *
 * 팀 뷰가 있는 앱은 그 화면을, 없는 앱은 **자기 단체 기본 뷰와 같은 설정**을 넘긴다 — 주소는 앱마다 같고 보여줄 화면만 앱이 정한다. 팀 입장 세션의 접근 상한은 서버가 집행하므로
 * 팀 뷰가 없는 앱의 단체 화면이 단체 범위 API를 부르면 서버가 403(`OUT_OF_ENTRY_SCOPE`)으로 막는다 — 팀 뷰를 만들기 전까지의 의도된 한계다.
 *
 * 전제: 앱이 `withComponentInputBinding()`과 `withRouterConfig({ paramsInheritanceStrategy: 'always' })`를 켜 `:orgId`·`:teamId`를 화면이 읽을 수 있다.
 * 프리픽스 구조는 `tools/ci/lint-angular-org-route-structure.mjs`가 강제한다.
 */
export function orgTeamEntryRoute(target: OrgTeamEntryTarget): Route {
  return { pathMatch: 'full', ...target, path: 'teams/:teamId' };
}
